import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../styles/colors.css';

const CardText = ({ title, description, coverImage, content }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <>
      {/* Tarjeta en estado normal */}
      {!isExpanded && (
        <motion.div
          onClick={handleExpand}
          className="p-6 card-text flex-1 cursor-pointer block overflow-hidden"
          whileHover={{ scale: 1.05 }}
        >
          <h4 className="text-xl font-bold">{title}</h4>
          <p className="mt-4">{description}</p>
        </motion.div>
      )}

      {/* Vista expandida */}
      <AnimatePresence>
        {isExpanded && (
          <motion.div
            className="fixed inset-0 z-50 flex justify-center items-center overflow-y-auto"
            style={{ backgroundColor: 'var(--background-color-typeA' }}
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50 }}
            transition={{ duration: 0.3 }}
          >
            <div
              className="  card-text w-full max-w-3xl mx-auto relative flex flex-col h-full sm:h-auto"
            >
              {/* Imagen de portada */}
              {coverImage && (
                <div className="w-full h-64 sm:h-48">
                  <img
                    src={coverImage}
                    alt={`${title} cover`}
                    className="w-full h-full object-cover rounded-t-lg"
                  />
                </div>
              )}

              {/* Contenido */}
              <div className="p-6 overflow-y-auto flex-1">
                <h4 className="text-2xl font-bold mb-4">{title}</h4>
                <p className="mb-4">{description}</p>
                <div className="text-left space-y-4">{content}</div>
              </div>

              {/* Botón de cierre */}
              <button
                onClick={handleExpand}
                className="absolute top-4 right-4 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-100 rounded-full p-2 focus:outline-none hover:bg-gray-300 dark:hover:bg-gray-600"
                style={{ zIndex: 100 }}
              >
                ✕
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default CardText;
